import React, {useState, useEffect, useRef} from 'react';
import styles from './lazy.module.css';

interface ImageOnScrollProps {
    SrcImage: string,
    alt: string,
    className?: any
}

const Lazy: React.FC<ImageOnScrollProps> = ({SrcImage, className}) => {
    const [isVisible, setIsVisible] = useState(false); // State to track visibility
    const imageRef = useRef<HTMLImageElement | null>(null);

    // Handle scroll event and check if the image is 30% in the viewport
    const handleScroll = () => {
        if (imageRef.current) {
            const rect = imageRef.current.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            // Check if the image is at least 30% visible in the viewport
            // const isInViewport = rect.top <= viewportHeight * 0.7 && rect.bottom >= viewportHeight * 0.3;
            const isInViewport = rect.top < viewportHeight && rect.bottom > 0;

            // If the image is in the viewport, show it
            if (isInViewport && !isVisible) {
                setIsVisible(true);
            }

            // If the image is not in the viewport AND the user is at the top of the page (i.e., scrolling up),
            // hide the image
            if (rect.top > viewportHeight && isVisible) {
                setIsVisible(false); // Reset visibility when scrolling back up past the image
            }
        }
    };

    useEffect(() => {
        // Set up scroll event listener
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check visibility on initial render

        return () => {
            // Clean up event listener on unmount
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isVisible]); // Re-run the effect if isVisible changes

    return (
        <div className={styles.image_section}>
            {/*<img*/}
            {/*    ref={imageRef}*/}
            {/*    src={SrcImage}*/}
            {/*    alt="Lazy-loaded image"*/}
            {/*    className={`${styles.revealed_image} ${isVisible ? styles.visible : ''}`}*/}
            {/*    loading="lazy" // Enable lazy loading*/}
            {/*/>*/}
            <img
                ref={imageRef}
                src={SrcImage}
                alt={"Lazy-loaded image"}
                className={`${styles.revealed_image} ${isVisible ? styles.visible : ''} ${className || ''}`}
                loading="lazy"
            />
        </div>
    );
};

export default Lazy;
